// extracted by mini-css-extract-plugin
module.exports = {"head":"head___1hIMV","list":"list___VaSEm"};